import React from "react";
import PropTypes from "prop-types";
import Ripple from "components/ripple";

import styles from "./button.scss";
function Button(props) {
    const { type, children, displayName, disabled, onClick, variant, buttonClass, ...optionalProps } = props;
    return (
        <button
            {...optionalProps}
            type={type}
            value={displayName}
            disabled={disabled}
            onClick={!disabled ? onClick : null}
            className={`${buttonClass} ${styles[variant]}`}
        >
            <Ripple {...optionalProps} className={styles.btnContent } onClick={!disabled ? onClick : null}>{children ? children : displayName}</Ripple>
        </button>
    );
}
Button.defaultProps = {
    type: "button",
    displayName: "Submit",
    buttonClass: ``,
    variant: "activebtn",
    disabled: false,
};
Button.propTypes = {
    type: PropTypes.string,
    displayName: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    buttonClass: PropTypes.string,
};
export default Button;
